import client from './client';

export const listEmployeesApi = async () => {
  const { data } = await client.get('/employees');
  return data;
};

export const createEmployeeApi = async (payload) => {
  const { data } = await client.post('/employees/create', payload);
  return data;
};

export const updateEmployeeApi = async (id, payload) => {
  const { data } = await client.put(`/employees/${id}`, payload);
  return data;
};

export const deleteEmployeeApi = async (id) => {
  const { data } = await client.delete(`/employees/${id}`);
  return data;
};

export const approveEmployeeApi = async (id, payload) => {
  const { data } = await client.post(`/employees/${id}/approve`, payload);
  return data;
};

export const rejectEmployeeApi = async (id, payload) => {
  const { data } = await client.post(`/employees/${id}/reject`, payload);
  return data;
};

export const transferEmployeeApi = async (id, newMotherId) => {
  const { data } = await client.post(`/employees/${id}/transfer`, { newMotherId });
  return data;
};


